module.exports = __webpack_public_path__ + "img/forestgreen.f202a3f.webp";